export default {
  lightBlue: '#63C3D1',
  darkBlue: '#2F334B',
  lightGray: '#DAE0E3',
  darkGray: '#2e334a',
  error: '#E7344D',
  success: '#388e3c',
  warning: '#FF931E',
  white: '#FFF',
  black: '#000',
  yellowFestGourmet: '#F49F0A',
  bestBlack: '#121212',
} as const;
